import styled from "styled-components"

import { ChevronLeftIcon } from "@minuthq/meatball-ui-icons"
import { Badge, Button, spacing, Text } from "@minuthq/meatball-ui-react"

import { detailsBreakpoint } from "src/components/GuestInbox/GuestConversations/guestConversationStyles"
import { TGuest } from "src/data/guests/types/guestTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { useRouter } from "src/router/useRouter"
import { MButton } from "src/ui/Button/MButton"

export function GuestConversationHeader({
  guest,
  onResolve,
  onDetailsClick,
  showBackButton = true,
  isResolving,
}: {
  guest: TGuest
  onResolve: () => void
  onDetailsClick: () => void
  showBackButton?: boolean
  isResolving?: boolean
}) {
  const { tPlaceholder } = useTranslate()

  const { navigate } = useRouter()

  return (
    <div>
      {showBackButton && (
        <BackButton
          onClick={() => navigate(Routes.Inbox.location())}
          startIcon={<ChevronLeftIcon width={16} height={16} />}
          variant="minimal"
          color="neutral"
          size="x-small"
        >
          {tPlaceholder("Back to the inbox")}
        </BackButton>
      )}

      <Wrapper>
        <Text variant="heading3">{guest.name}</Text>
        <ButtonsWrapper>
          <DetailsButton
            variant="minimal"
            color="neutral"
            onClick={onDetailsClick}
          >
            {tPlaceholder("Details")}
          </DetailsButton>

          {guest.conversation?.status === "resolved" ? (
            <Badge color="good" size="medium">
              {tPlaceholder("Resolved")}
            </Badge>
          ) : (
            <Button
              color="neutral"
              size="small"
              onClick={onResolve}
              loading={isResolving}
            >
              {tPlaceholder("Resolve")}
            </Button>
          )}
        </ButtonsWrapper>
      </Wrapper>
    </div>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ButtonsWrapper = styled.div`
  display: flex;
  gap: ${spacing.S};
  align-items: center;
`

const BackButton = styled(MButton)`
  margin-bottom: ${spacing.S};
`

const DetailsButton = styled(Button)`
  @container (${detailsBreakpoint}) {
    display: none;
  }
`
